import { Controller } from "@hotwired/stimulus";
import { remove } from "lodash-es";
import { pushUnique } from "../../lib/helpers";

export default class extends Controller {
  static targets = [
    "calculateYear",
    "plannedYearInput",
    "previouslyCompletedInput",
  ];
  static values = {
    id: String,
    plannedYearInterval: String,
  };

  classNames = {
    calculateYearExpanded: "selected-suggestion-calculate-year--expanded",
    selectedSuggestionHighlight:
      "manage-components-selected-list__item--highlighted",
  };

  suggestionSelectionController = null;

  connect() {
    if (this.isNewlyAdded()) {
      remove(
        this.suggestionSelection.newlyAddedSuggestions,
        (id) => id === this.idValue
      );

      this.element.classList.add(this.classNames.selectedSuggestionHighlight);
      this.element.scrollIntoView({ behavior: "smooth", container: "nearest" });
    }

    if (this.shouldCalculateYearBeExpanded()) {
      this.calculateYearTarget.classList.add(
        this.classNames.calculateYearExpanded
      );
    }
  }

  disconnect() {
    // Clear expanded state on disconnect
    remove(
      this.suggestionSelection.states.selectedSuggestionCalculateYear,
      (id) => id === this.idValue
    );
  }

  deselectSuggestion(event) {
    event.stopPropagation(); // Prevent pop out to close

    this.element.remove();

    this.suggestionSelection.form.submit();
  }

  toggleCalculateYear() {
    this.calculateYearTarget.classList.toggle(
      this.classNames.calculateYearExpanded
    );

    if (this.isCalculateYearExpanded()) {
      pushUnique(this.calculateYearExpandedState, this.idValue);
    } else {
      remove(this.calculateYearExpandedState, (id) => id === this.idValue);
    }
  }

  calculateYear() {
    const previouslyCompleted = parseInt(
      this.previouslyCompletedInputTarget.value
    );
    const interval = parseInt(this.plannedYearIntervalValue);

    if (isNaN(previouslyCompleted) || isNaN(interval)) return;

    const calculatedYear = Math.max(
      previouslyCompleted + interval,
      new Date().getFullYear() + 1
    );
    this.plannedYearInputTarget.value = calculatedYear;
    this.toggleCalculateYear();
  }

  isNewlyAdded() {
    return this.suggestionSelection.newlyAddedSuggestions.includes(
      this.idValue
    );
  }

  shouldCalculateYearBeExpanded() {
    return this.calculateYearExpandedState.includes(this.idValue);
  }

  isCalculateYearExpanded() {
    return this.calculateYearTarget.classList.contains(
      this.classNames.calculateYearExpanded
    );
  }

  get suggestionSelection() {
    if (!this.suggestionSelectionController) {
      const parentControllerElement = this.element.closest(
        '[data-controller*="facility-generate-component-actions--suggestion-selection"]'
      );
      this.suggestionSelectionController =
        this.application.getControllerForElementAndIdentifier(
          parentControllerElement,
          "facility-generate-component-actions--suggestion-selection"
        );

      if (!this.suggestionSelectionController) {
        throw new Error("Suggestion selection controller not found");
      }
    }
    return this.suggestionSelectionController;
  }

  get calculateYearExpandedState() {
    return this.suggestionSelection.states.selectedSuggestionCalculateYear;
  }
}
